import React from "react"

interface TruncatedTextProps {
  text: string
  maxLength?: number
  className?: string
}

export const TruncatedText: React.FC<TruncatedTextProps> = ({
  text,
  maxLength = 25,
  className = "",
}) => {
  if (!text || text.length <= maxLength) return <span className={className}>{text}</span>

  const truncatedText = text.substring(0, maxLength) + "..."

  return (
    <span className={`${className} cursor-help relative group`} title={text}>
      {truncatedText}
      {/* Custom tooltip for better visibility */}
      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 sm:px-4 py-2 sm:py-3 bg-gray-900 text-white text-xs sm:text-sm rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50 min-w-48 sm:min-w-64 max-w-xs sm:max-w-md break-words">
        {text}
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-900"></div>
      </div>
    </span>
  )
}
